import { Permiso_tramitado } from './../../../models/permiso_tramitado.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FormService } from 'src/app/services/form.service';

@Component({
  selector: 'app-permiso-tramitado',
  templateUrl: './permiso-tramitado.component.html',
  styleUrls: ['./permiso-tramitado.component.css'],
  providers: [FormService]
})
export class PermisoTramitadoComponent {
  public rows = [];
  public actualRow;
  public permiso: Permiso_tramitado;
  public form1;
  public matcher = new FormService();
  public esp

  constructor() {
    this.form1 = new FormGroup({
      demolicion: new FormControl('', Validators.required),
      otrosEsp: new FormControl('', Validators.required),

      especificar: new FormControl('', Validators.required),
      solicitud1: new FormControl('', Validators.required),
      fecha1: new FormControl('', Validators.required),
      solicitud2: new FormControl('', Validators.required),
      fecha2: new FormControl('', Validators.required),
      solicitud3: new FormControl('', Validators.required),
      fecha3: new FormControl('', Validators.required)

    })
    if (!JSON.parse(localStorage.getItem("permiso"))) {
      localStorage.setItem("permiso", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("permiso"));
      this.form1.controls['demolicion'].setValue(this.rows[0] ? this.rows[0].demolicion : "");
      this.form1.controls['otrosEsp'].setValue(this.rows[0] ? this.rows[0].otrosEsp : "");
      this.form1.controls['especificar'].setValue(this.rows[0] ? this.rows[0].especificar : "");

      this.form1.controls['solicitud1'].setValue(this.rows[0] ? this.rows[0].solicitud1 : "");
      this.form1.controls['fecha1'].setValue(this.rows[0] ? this.rows[0].fecha1 : "");
      this.form1.controls['solicitud2'].setValue(this.rows[0] ? this.rows[0].solicitud2 : "");
      this.form1.controls['fecha2'].setValue(this.rows[0] ? this.rows[0].fecha2 : "");
      this.form1.controls['solicitud3'].setValue(this.rows[0] ? this.rows[0].solicitud3 : "");
      this.form1.controls['fecha3'].setValue(this.rows[0] ? this.rows[0].fecha3 : "");

    }
    this.permiso = {
      demolicion: '',
      otrosEsp: '',
      especificar: '',

      solicitud1: '',
      fecha1: '',
      solicitud2: '',
      fecha2: '',
      solicitud3: '',
      fecha3: ''
    };
  }

  add_condiciones() {
    console.log(this.form1);
    console.log(this.form1.value.demolicion);
    if (this.form1.value.otrosEsp) {
      this.esp = this.form1.value.especificar
    } else {
      this.esp = ""
    }

    localStorage.setItem("permiso", JSON.stringify([]));
    this.actualRow = localStorage.getItem("permiso");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      demolicion: this.form1.value.demolicion,
      otrosEsp: this.form1.value.otrosEsp,
      especificar: this.esp,

      solicitud1: this.form1.value.solicitud1,
      fecha1: this.form1.value.fecha1 ? moment(this.form1.value.fecha1).format('DD/MM/YYYY') : "",
      solicitud2: this.form1.value.solicitud2,
      fecha2: this.form1.value.fecha2 ? moment(this.form1.value.fecha2).format('DD/MM/YYYY') : "",
      solicitud3: this.form1.value.solicitud3,
      fecha3: this.form1.value.fecha3 ? moment(this.form1.value.fecha3).format('DD/MM/YYYY') : "",
    })
    localStorage.setItem("permiso", JSON.stringify(this.rows));
  }

  delete_condiciones(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("permiso", JSON.stringify(this.rows));
      }
    }
  }
}
